import { HomepageOption } from '@appTypes/essential-ui/HomepageOption';
import { Initial } from '@appTypes/Initial';
import { SalesPerson } from '@appTypes/SalesPerson';
import { StoreDetails } from '@appTypes/StoreDetails';
import { GetOneFromPath } from '@services/api/GenericClient';
import { checkMobileDevice } from '@services/utils/CheckMobileDevice';

async function getInitial(storeCode: string): Promise<Initial> {
  const path = `/common/initial?storeCode=${storeCode}`;
  return await GetOneFromPath<Initial>(path, !storeCode);
}

async function getSalesPersons(storeCode: string): Promise<SalesPerson[]> {
  const path = `/common/getActiveUserInfo?storeCode=${storeCode}`;
  return await GetOneFromPath<SalesPerson[]>(path, !storeCode);
}

async function getStores(): Promise<StoreDetails[]> {
  const url = `/common/stores`;
  return await GetOneFromPath<StoreDetails[]>(url);
}

async function getHomePageOption() {
  return await GetOneFromPath<HomepageOption>(`/common/homepageoption`);
}

async function getHomePageOptionUrl() {
  const { isMobileDevice } = checkMobileDevice();
  return new Promise((resolve) => {
    getHomePageOption().then((response) => {
      let url: string;
      if (isMobileDevice && (response.homepageOption === 0 || response.homepageOption === 1)) {
        url = '/portfolio/all';
      } else {
        switch (response.homepageOption) {
          case 0:
            url = '/portfolio/lease';
            break;
          case 1:
            url = '/portfolio/finance';
            break;
          case 7:
            url = '/portfolio/all';
            break;
          case 8:
            url = '/essential/dashboard';
            break;
          default:
            url = '/portfolio/all';
        }
      }

      resolve(url);
    });
  });
}

export const CommonService = {
  getInitial,
  getSalesPersons,
  getStores,
  getHomePageOption,
  getHomePageOptionUrl,
};
